import React, { useCallback } from 'react'
import { useSearchParams } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'

const isShallowEqual = (a, b) => {
  return (
    Object.keys(a).every(prop => a[prop] == b[prop]) &&
    Object.keys(b).every(prop => b[prop] == a[prop])
  )
}

const withQueryParams = () => {
  return WrappedComponent => {
    const WithQueryParams = props => {
      const dispatch = useDispatch()
      const [searchParams, setSearchParams] = useSearchParams()
      const query = Object.fromEntries([...searchParams])
      const routerQuery = useSelector((state) => state.router.match.query)

      const addQueryParams = useCallback(queryparams => {
        const newParams = { ...query, ...queryparams }
        Object.keys(newParams).forEach(prop => {
          if (newParams[prop] == null) {
            delete newParams[prop]
          }
        })
        setSearchParams(newParams)
      }, [query])

      React.useEffect(() => {
        if (
          !routerQuery ||
          !isShallowEqual(query, routerQuery)
        ) {
          dispatch({
            type: 'UPDATE_ROUTER_QUERY',
            query
          })
        }
      }, [query])

      return <WrappedComponent {...props} addQueryParams={addQueryParams} />
    }
    return WithQueryParams
  }
}

export default withQueryParams
